/**
 * External dependencies
 */
import Swiper from 'swiper';
import { Keyboard, Navigation, Pagination, Thumbs } from 'swiper/modules';

document.addEventListener('DOMContentLoaded', () => {
    const params = {
        spaceBetween: 30,
        loop: true,
        autoHeight: false,
        keyboard: {
            enabled: true
        },
        navigation: {
            nextEl: '.snla-images-carousel__icon--next',
            prevEl: '.snla-images-carousel__icon--prev'
        },
        pagination: {
            el: '.swiper-pagination',
            clickable: true
        },
        watchSlidesProgress: true,
        modules: [Navigation, Pagination, Keyboard, Thumbs]
    };

    const imageCarousels = document.querySelectorAll('.snla-image-carousel-swiper');

    if (imageCarousels) {
        [].forEach.call(imageCarousels, carousel => {
            // select next element that is .snla-image-carousel-swiper-thumbs
            const thumbCarousel = carousel.nextElementSibling;

            let sliderConfig = {};

            if (
                thumbCarousel &&
                thumbCarousel.classList.contains('snla-image-carousel-thumbnails')
            ) {
                const thumbParams = {
                    freeMode: true,
                    spaceBetween: 30,
                    slidesPerView: 4,
                    watchSlidesProgress: true,
                    loop: true,
                    autoHeight: false
                };

                const thumbSliderConfig = {};

                const thumbSwiper = new Swiper(thumbCarousel, {
                    ...thumbParams,
                    ...thumbSliderConfig
                });

                sliderConfig = {
                    thumbs: {
                        swiper: thumbSwiper
                    }
                };
            }

            // eslint-disable-next-line no-new
            new Swiper(carousel, {
                ...params,
                ...sliderConfig
            });
        });
    }
});
